<template>
<div v-if="isShow">
    <header>ポイント表<div class="h-left"><a @click="$emit('close')"><img src="~@/assets/images/icon02.svg"></a></div>
    </header>
    <div id="wrap" v-if="point">
        <div class="search-form-title">アクションによってプラスされるポイント</div>
        <div class="porf-area">
            <table>
                <tr v-for="item in Object.values(point.increase)" :key="item">
                    <td>{{ item.name }}</td>
                    <td class="right">{{ item.point }}</td>
                </tr>
            </table>
        </div>
        <div class="search-form-title">アクションによってマイナスされるポイント</div>
        <div class="porf-area">
            <table>
                <tr v-for="item in Object.values(point.decrease)" :key="item">
                    <td>{{ item.name }}</td>
                    <td class="right">{{ item.point }}</td>
                </tr>
            </table>
        </div>
    </div>
</div>
<div class="loading-screen" style="opacity: 0.6" v-if="isLoading">
    <div class="loader"></div>
</div>
</template>

<script>
import {
  mapGetters
} from "vuex"
export default {
    props: {
        isShow: Boolean,
    },
    emits: ['close'],
    data: () => ({
        point: null,
        isLoading: false
    }),
    computed: {
        ...mapGetters(["metadata", 'defaultToken']),
    },
    mounted() {
        this.getPointSettingList()
    },
    methods: {
        getPointSettingList() {
            this.isLoading = true
            this.$store.dispatch('profile/getPointSettingList', {
                token: this.defaultToken
            }).then(data => {
                this.point = data
                this.isLoading = false
            }).catch(e => {
                this.isLoading = false
                console.log(e);
            })
        },
    },
    
}
</script>
